export const phoneExpression = /^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
export const numbersAndLetter = /^[a-zA-Z0-9]+$/;
export const currencyFormat = /^\$?\d+\.?\d{0,2}$/;
